import { H2 } from '@comeon/ui';

import { Translations } from '~/components/payment/quick-deposit-beta/components-v2/types';
import { TAction, TriggerViewFn } from '~/components/payment/quick-deposit-beta/types';
import {
	LIMITS_REDIRECT_CONFIRM,
	textKeysQDAmountScreen
} from '~/components/payment/quick-deposit-beta/utils/constants';

// Styled components
import { CloseButton, HeadWrapper, RoundedButtonSecondary, SubTitle } from './styles';
import { ContentWrapper } from '~/components/payment/quick-deposit-beta/components-v2/deposit-amount/styles';

type Props = {
	addView: (...args: string[]) => TAction;
	formattedLimit: string;
	handleClose: () => void;
	isLugasLimit: boolean;
	translation: Translations<typeof textKeysQDAmountScreen>;
	updateViews: (...args: ReturnType<TriggerViewFn>[]) => TAction;
};

const NewQDRGScreen = ({ formattedLimit, addView, handleClose, translation: t, updateViews, isLugasLimit }: Props) => {
	return (
		<>
			<HeadWrapper>
				<H2 data-at="main-title-deposit-limit">
					{isLugasLimit ? t.LUGAS_LIMIT_REACHED_TITLE : t.DEPOSIT_LIMITS_TEMPLATE_TITLE}
				</H2>
				<CloseButton className="at-icon-close page-head__close" onClick={handleClose} type="button" />
			</HeadWrapper>
			<ContentWrapper>
				<SubTitle dataAt="sub-title-deposit-limit">
					{isLugasLimit ? t.LUGAS_LIMIT_REACHED_MESSAGE : `${t.SELIMIT_REACHED_MESSAGE} ${formattedLimit}`}
				</SubTitle>
				<RoundedButtonSecondary
					smallfont
					onClick={() => updateViews(addView(LIMITS_REDIRECT_CONFIRM))}
					type="submit"
					className="u-relative button u-mb1"
					title="title"
					dataAt="new-mobile-quick-deposit-update-limits"
				>
					{t.UPDATE_DEPOSIT_LIMIT}
				</RoundedButtonSecondary>
			</ContentWrapper>
		</>
	);
};

export default NewQDRGScreen;
